import React, {useState} from 'react';
import {Dialog, DialogContent, Button, Alert, AlertTitle} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import axios from 'axios';
import ConfirmationModal from '../ConfirmationModal/ConfirmationModal';
import CaseNotificationEnum from '../../enums/CaseNotiFicationEnum';
import CaseMergeDecline from "./caseMergeDecline";

function AnswerToMergeCase({open, onClose, onMerge, caseData, users, onDeny, dateTime, fullName, previewHtml}) {
    const urlParams = new URLSearchParams(window.location.search);
    const caseId = urlParams.get('id');
    const [isOpenMergeModal, setIsMegreModalOpen] = useState(false);
    const [isDenyDialogOpen, setIsDenyModalOpen] = useState(false);
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);

    const handleOpenCase = () => {
        const url = `/dashboard/mycases/casemanager?id=${caseData.mergeCaseID}`;
        window.open(url, '_blank');
    };


    const deleteCase = async (caseId) => {
        const payload = {
            id: caseId,
        }

        await axios.put(`${process.env.REACT_APP_API_BASE_URL}/ DeleteCaseByAdminAndInternal`, payload);
    };

    const sendNotification = async () => {
        const headOfAgency = users.find(user => user.roleName === 'HeadOfAgency');

        const caseNotification = {
            nextStepUserId: headOfAgency.id,
            caseId: caseId ? parseInt(caseId, 10) : 0,
            documentId: null,
            action: CaseNotificationEnum.mergedCase.id,
            caseStatus: 8,
            viewed: true,
        };

        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);
    };

    const handleMerge = async () => {
        if (caseData.mergeCaseID) {
            const payload = {
                expertCaseId: parseInt(caseData.mergeCaseID, 10),
                caseId: parseInt(caseId, 10),
                oldCaseNumber: '',
            };

            try {
                await axios.post(`${process.env.REACT_APP_API_BASE_URL}/MargeCase`, payload);
                await sendNotification();
                await deleteCase(parseInt(caseData.mergeCaseID, 10));
                onMerge();
                setIsMegreModalOpen(false);
                onClose();
                setShowSuccessAlert(true); // Show success alert
                setTimeout(() => setShowSuccessAlert(false), 3000);
            } catch (error) {
                console.error('Error merging cases:', error);
            }
        } else {
            const body = {
                id: caseId
            };
            const headOfAgency = users.find(user => user.roleName === "HeadOfAgency");

            const caseNotification = {
                nextStepUserId: headOfAgency.id,
                caseId: caseId ? parseInt(caseId, 10) : 0,
                documentId: null,
                action: CaseNotificationEnum.movedCaseToObjectRegistery.id,
                caseStatus: 8,
                viewed: true,
            };
            try {
                await axios.post(`${process.env.REACT_APP_API_BASE_URL}/MoveCaseToRegisterByexpert`, body);
                await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);
                onMerge();
                onClose();
            } catch (error) {
                console.error('Error merging cases:', error);
            }
        }

    };

    return (
        <div>


            <Dialog open={open} onClose={onClose}>
                <DialogContent>
                    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                        {caseData.mergeCaseID && (
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleOpenCase}
                                style={{margin: '10px 0', width: '400px'}}
                                endIcon={<InfoIcon/>}
                            >
                                გასაერთიანებელი განაცხადის ნახვა
                            </Button>
                        )}
                        <Button
                            variant="contained"
                            color="success"
                            style={{margin: '10px 0', width: '400px'}}
                            onClick={() => setIsMegreModalOpen(true)}
                            endIcon={<CheckCircleIcon/>}
                        >
                            ობიექტის გადატანა უწყებრივ რეესტრში
                        </Button>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={() => setIsDenyModalOpen(true)}
                            style={{margin: '10px 0', width: '400px'}}
                            endIcon={<CancelIcon/>}
                        >
                            გადატანაზე უარის თქმა
                        </Button>
                    </div>
                    <CaseMergeDecline closeModal={onClose} open={isDenyDialogOpen}
                                      onClose={() => setIsDenyModalOpen(false)} onDeny={onDeny} caseData={caseData}
                                      users={users}/>
                </DialogContent>
                <ConfirmationModal
                    previewHtml={previewHtml}
                    dateTime={dateTime}
                    fullName={fullName}
                    isOpen={isOpenMergeModal}
                    onRequestClose={() => setIsMegreModalOpen(false)}
                    onConfirm={handleMerge}
                    caseID={caseData.mergeCaseID ? caseData.mergeCaseID : null}
                    modalText={caseData.mergeCaseID ? `დარწმუნებული ხართ რომ გსურთ განაცხადების გაერთიანება? ექსპერტის მიერ შევსებული ველები გადაეწერება მოქალაქის მიერ შევსებულ ველებს, ექსპერტის მიერ შექმნილი განაცხადის სანახავად გამოიყენეთ  "უნომრო ობიექტის ნახვა" ღილაკი. ` : "დარწმუნებული ხართ, რომ გსურთ ობიექტის გადატანა უწყებრივ რეესტრში?"}
                />
            </Dialog>
        </div>
    );
}

export default AnswerToMergeCase;
